import { render, staticRenderFns } from "./ModalSection.vue?vue&type=template&id=dda7381e&scoped=true"
import script from "./ModalSection.vue?vue&type=script&lang=js"
export * from "./ModalSection.vue?vue&type=script&lang=js"
import style0 from "./ModalSection.vue?vue&type=style&index=0&id=dda7381e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dda7381e",
  null
  
)

export default component.exports